import TR from 'utils/TR';
import Segment from 'components/common/Segment';
import T from 'utils/T';
import ex from 'utils/ex';
import CHECK_COLORS from 'constants/CHECK_COLORS';

export default function AverageGlycemicIndexBox(props) {
  const {
    data,
    ...rest
  } = props || {};

  const {
    avg_bld_sugr,
  } = data || {};

  return (
    <Segment {...ex(['OverviewSummaryBox', 'AverageGlycemicIndexBox', 'normal'], rest)}>
      <div>
        {T('평균혈당')}
      </div>
      <div>
        <div {...ex(['BASE_COLOR', CHECK_COLORS('B', avg_bld_sugr)])}>
          {avg_bld_sugr}
        </div>
        <div>
          {T('mg/dL')}
        </div>
      </div>
    </Segment>
  );
}
